/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Agent_TranslateInputs */



/**
* | output |
* | --- |
* | "Translate the subtitles to French in a new Event Group" |
*
* @param {Assistant_Suggest_Agent_TranslateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_agent_translate = /** @type {((inputs?: Assistant_Suggest_Agent_TranslateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Agent_TranslateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traduisez les sous-titres en français dans un nouveau groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzen Sie die Untertitel in einer neuen Ereignisgruppe ins Französische.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traduci i sottotitoli in francese in un nuovo gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переведите субтитлы на французский язык в новой группе событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Traduzca los subtítulos al francés en un nuevo grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在新事件组中将字幕翻译成法语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントグループで字幕をフランス語に翻訳する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए इवेंट ग्रुप में उपशीर्षकों का फ्रेंच में अनुवाद करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Traduzir as legendas para francês em um novo Grupo de Eventos")
	return /** @type {LocalizedString} */ ("Translate the subtitles to French in a new Event Group")
});